module.exports = __webpack_public_path__ + "img/photo-25.1fa451e6.jpg";